import axios from "axios";
// import handleError from "./HandleError";
import API from "./APIService";
import BaseService from "./BaseService";

class ProjectsService extends BaseService {
    component = null;
	options = null;
    
	constructor(component, options) {
    	super(); 
    	this.component = component;
    	this.options = options;
	}

    baseServicePath = () => {
    	if(this.options) {
    		return API.url(`projects${this.options}`);
    	}

    	return API.url("projects");
    };
	
	changeStatus = (id, data) => {
		if (id && data) {
			if (this.baseServicePath != null) {
				return axios.put(`${this.baseServicePath()}/${id}/status`, data);
			}
			throw new Error("baseServicePath is not defined");
		}
		throw new Error("Parameters not defined");
	}
}

export default ProjectsService;


// WEBPACK FOOTER //
// ./src/services/ProjectsService.js